import { useGetUserGroupGrades } from '@repo/api/grade/useGetUserGroupGrades';
import { Link } from 'react-router';

import GradeCard from '@/components/features/grades/GradeCard';
import GradesEmptyState from '@/components/features/grades/GradesEmptyState';
import GroupPageErrorState from '@/components/features/groups/layout/GroupPageErrorState';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { Skeleton } from '@/components/ui/skeleton';

interface StudentGroupGradesProps {
  groupId: number;
  userId?: number;
}

export default function StudentGroupGrades({ groupId, userId }: StudentGroupGradesProps) {
  const { data: grades = [], isPending, isError, errorMessage } = useGetUserGroupGrades(userId, groupId);

  if (isError) {
    return <GroupPageErrorState errorMessage={errorMessage} />;
  }

  return (
    <div className="base-direction-col">
      <div className="bg-background border-border-primary flex h-full w-full flex-col rounded-2xl border">
        <div className="border-border-primary border-b p-4">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to={`/groups/${groupId}`}>Grupa</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Oceny</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <div className="flex flex-col overflow-auto">
          {isPending ? (
            <div className="flex flex-col gap-2 p-4">
              <Skeleton className="h-12 w-full" />
              <Skeleton className="h-12 w-full" />
              <Skeleton className="h-12 w-full" />
            </div>
          ) : grades.length ? (
            <div className="[&>*:nth-child(odd)]:bg-card/25 [&>*:not(:last-child)]:border-border-primary/75 [&>*:not(:last-child)]:border-b">
              {grades.map((grade) => (
                <GradeCard key={grade.id} grade={grade} className="px-4" />
              ))}
            </div>
          ) : (
            <div className="p-4">
              <GradesEmptyState description="Nie masz jeszcze żadnych ocen w tej grupie" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
